<template>
    <div class="refund-info">

        <div class="info_list">
            <div class="info_title">
                <div>报考信息</div>
            </div>

                <div class="van-cell van-cell--large van-field">
                    <div class="van-cell__title van-field__label">
                        <span>报考科目</span>
                    </div>
                    <div class="van-cell__value van-field__value">
                        <div class="van-field__body">
                            {{skuinfo.title}}
                        </div>
                    </div>
                </div>
            <div class="van-cell van-cell--large van-field">
                <div class="van-cell__title van-field__label">
                    <span>报考证书</span>
                </div>
                <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                        {{skuinfo.name}}
                    </div>
                </div>
            </div>
            <div class="van-cell van-cell--large van-field">
                <div class="van-cell__title van-field__label">
                    <span>报考费用</span>
                </div>
                <div class="van-cell__value van-field__value">
                    <div class="van-field__body">
                        {{skuinfo.price}}
                    </div>
                </div>
            </div>
        </div>

         <div class="info_list">
            <div class="info_title">
                <div>退款原因</div>
            </div>
             <van-field
                        type="textarea"
                        clickable
                        name="content"
                        v-model="form.reason"
                        placeholder="请填写退款原因"
                        rows="6"
                        autosize
                        class="reason"
                        required
                />


         </div>

        <div class="footer" >
            <van-button type="primary" @click="confirm"  hairline round class="btn1">提交申请</van-button>
        </div>

    </div>

</template>
<script>
    import utils from '../../../libs/utils'
    import wechat from '../../../libs/wechat'
    import {Cell, CellGroup,Field,RadioGroup, Radio,Button,Calendar,Uploader,Toast,Picker,Popup,Dialog,Image,ImagePreview,CheckboxGroup,Checkbox} from 'vant'
    import axios from 'axios'
    export default {
        name: "coinRecord",
        components: {
            vanCell:Cell,
            vanCellGroup:CellGroup,
            vanField:Field,
            vanRadioGroup:RadioGroup,
            vanRadio:Radio,
            vanButton:Button,
            vanCalendar:Calendar,
            vanUploader:Uploader,
            vanPicker:Picker,
            vanPopup:Popup,Dialog,
            vanImage:Image,
            ImagePreview,
            vanCheckboxGroup:CheckboxGroup,
            vanCheckbox:Checkbox
        },
        data() {
            return {
                page:1,
                form:{orid:"",reason:""},
                orderid:'',
                skuinfo:{},
            }
        },
        methods: {
            gonext(){
                // let
                this.$router.back(-1)
            },
            viewPic(picurl)
            {
                ImagePreview([picurl]);
            },
            getDetail(){
                let that = this;
                this.$api.user.myApplydetail({id:this.orderid}).then((res)=>{
                    if(res.code==200){
                       
                        that.skuinfo = res.data.skuinfo
                       
                    }
                })
            },
            confirm() {
                let that = this
                 if(that.form.reason.length<1)
                {
                        Dialog.alert({
                            title: '提示',
                            message: "退款原因不能为空",
                        });
                        return false;
                }
                Dialog.confirm({title: '提示',message:'您确定要申请退款吗？'}).then(() => {
                        that.$api.order.refundOrder(that.form).then((res)=>{
                            if(res.code==245)
                            {
                                Dialog.confirm({
                                title: '提示',
                                message:res.message,
                                showCancelButton:false
                                }).then(() => {
                                    that.$router.push({name:'refunddetail',params:{'ordersn':res.data.ordersn}})
                                })
                            }else{
                                that.$router.back(-1)
                            }
                        })
                    });
            }

        },
        mounted() {
            this.$nextTick(() => {
                this.form.orid = this.orderid = this.$route.params.orderid
                this.getDetail()
            })
        }
    }
</script>

<style lang="less" src="./index.less"></style>
